import CircleIcon from "@mui/icons-material/Circle";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

import type { ActivationPageProps } from "../types";

export function CarrierVoluntellActivationPage2(props: ActivationPageProps) {
  const { passwordField, submitButton, errorMessage } = props;

  const bulletItems = [
    "Activate your free account",
    "View available loads",
    "Start booking shipments",
  ];

  return (
    <Box>
      <Typography textAlign="center" variant="h4" fontWeight="bold">
        Evotrux is the fast, easy way to book freight online.
      </Typography>
      <Typography textAlign="center" mt={3}>
        No hidden fees or commissions. No credit card required. Enter a password
        to:
      </Typography>
      <Box display="flex" justifyContent="center" mt={2}>
        <List dense disablePadding>
          {bulletItems.map((item) => (
            <ListItem key={item} disablePadding disableGutters>
              <ListItemIcon sx={{ minWidth: 24 }}>
                <CircleIcon sx={{ fontSize: 8 }} />
              </ListItemIcon>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Box>
      <Stack my="2rem" mt="2rem" spacing={2}>
        {passwordField}
        {errorMessage}
        {submitButton}
      </Stack>
      <Typography textAlign="center" color="text.secondary" mt={1.5}>
        You&apos;re only one step away from booking loads on Evotrux. Create
        your password to activate your free account and get started. Have
        questions? Chat with us below and search our help centre.
      </Typography>
    </Box>
  );
}
